/* ============================================================
   Cathaya × Minimog — Anti-Scraper Shield (Medium)
   Deterrents only — NOT real security. The point is to raise
   the bar enough to filter out the 80% of casual scraping:
   right-click image-savers, drag-to-desktop users, default-
   config SaaS crawlers, script kiddies trying View Source.
   Determined scrapers with Puppeteer/Playwright will bypass
   everything below; that requires Cloudflare/Shopify Bot
   Protection at the platform layer, not theme JS.

   Active in Medium:
   - Block right-click context menu
   - Block image drag / long-press save
   - Block keyboard shortcuts:
       F12                    (open DevTools)
       Ctrl/Cmd + Shift + I/J (open DevTools)
       Ctrl/Cmd + U           (view source)
       Ctrl/Cmd + S           (save page)
       Ctrl/Cmd + P           (print → screenshot bypass)
   - Friendly bot allow-list (search engines never blocked,
     because we don't blank UA-matched pages in Medium)

   NOT in Medium (kept off to avoid hurting real users):
   - Text selection blocking on product zones (annoying — users
     copy product names to share with friends)
   - UA-based page blanking (false positives risk)
   - navigator.webdriver detection (breaks some a11y tools)

   Bypassed when:
   - Shopify designMode active (Theme Editor preview)
   - URL contains ?preview_theme_id (storefront preview)
   - URL contains ?cathaya_debug=1 (manual override for debugging)
   ============================================================ */

(function () {
  "use strict";

  function shouldBypass() {
    try {
      if (window.Shopify && Shopify.designMode) return true;
      var url = window.location.href;
      if (/[?&]preview_theme_id=/.test(url)) return true;
      if (/[?&]cathaya_debug=1/.test(url)) return true;
    } catch (e) {}
    return false;
  }
  if (shouldBypass()) {
    console.info("[cathaya-shield] bypassed (editor / preview / debug).");
    return;
  }

  // 1. Right-click context menu
  document.addEventListener("contextmenu", function (e) {
    e.preventDefault();
    return false;
  }, { capture: true });

  // 2. Image drag
  document.addEventListener("dragstart", function (e) {
    if (e.target && e.target.tagName === "IMG") {
      e.preventDefault();
      return false;
    }
  }, { capture: true });

  // 3. CSS: block iOS / Android long-press save
  var style = document.createElement("style");
  style.id = "cathaya-shield-css";
  style.textContent =
    "img { -webkit-user-drag: none; -webkit-touch-callout: none; }";
  document.head.appendChild(style);

  // 4. DevTool / view-source / save / print shortcuts
  document.addEventListener("keydown", function (e) {
    var k = e.key;
    var meta = e.metaKey || e.ctrlKey;
    if (k === "F12") { e.preventDefault(); return; }
    if (meta && e.shiftKey && (k === "I" || k === "i" || k === "J" || k === "j")) {
      e.preventDefault(); return;
    }
    if (meta && (k === "U" || k === "u")) { e.preventDefault(); return; }
    if (meta && (k === "S" || k === "s")) { e.preventDefault(); return; }
    if (meta && (k === "P" || k === "p")) { e.preventDefault(); return; }
  }, { capture: true });

  console.info("[cathaya-shield] Medium active. Bypass with ?cathaya_debug=1.");
})();
